import { render, staticRenderFns } from "./SetupPenjualan.vue?vue&type=template&id=fd27de72&"
import script from "./SetupPenjualan.vue?vue&type=script&lang=js&"
export * from "./SetupPenjualan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports